import React from 'react'
import { EmptyState } from './empty-state'
import { t } from '@lingui/core/macro'

interface EmptyStateProps {
  title?: string
  subtitle?: string
  image?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  extra?: React.ReactNode
}

export const EmptyList = ({ title, subtitle, image: Image, extra }: EmptyStateProps) => (
  <EmptyState>
    {Image && (typeof Image === 'string' ? <img src={Image} alt={t`Empty state`} /> : <Image />)}
    <EmptyState.Content>
      <EmptyState.TextWrapper>
        <h1 className="text-xl font-bold mb-4 text-center">{title}</h1>
        <p className="text-base">{subtitle}</p>
      </EmptyState.TextWrapper>
      <div>{extra}</div>
    </EmptyState.Content>
  </EmptyState>
)
